//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DetailConverter from '~/components/detail/mobile/detail_converter'
// import DetailInfosection from '~/components/detail/desktop/detail_infosection'
// import DetailMoreInfosection from '~/components/detail/desktop/detail_more_infosection'
export default {
  name: 'CoinDetail',
  components: { DetailConverter },
  props: {
    data: {
      type: Object,
      default: null
    },
    tetherData: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      selectedTab: 'buy'
    }
  },
  methods: {
    selectTab (tab) {
      this.selectedTab = tab
    }
  }
}
